import { FaArrowRight } from "react-icons/fa";
import WhatsappLink from "../../../utils/WhatsappLink";
import { useNavigateAndScroll } from "../../../hooks/useNavigateAndScroll";

const ELEMENTS = [
  {
    title: "Cumplimiento de normativas",
    subtitle:
      "Cumplimos con las regilaciones de encriptación y seguridad de datos más exigentes.",
    imgSrc: `${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/seguridad1.png`,
  },
  {
    title: "Acceso controlado",
    subtitle: "Solo tú y las personas autorizadas tendrán acceso a tus datos.",
    imgSrc: `${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/seguridad2.png`,
  },
  {
    title: "Integridad de los datos",
    subtitle:
      "Garantizamos la precisión y consistencia de la información que utilizas para tomar decisiones.",
    imgSrc: `${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/seguridad3.png`,
  },
];
const Otros = () => {
  const navigateAndScroll = useNavigateAndScroll();

  return (
    <>
      <section
        className="light-section"
        style={{ gap: "4rem", margin: "8rem 0 4rem 0" }}
      >
        <div className="columna">
          <img
            alt="integraciones"
            src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/integraciones.png`}
          />
        </div>
        <div className="columna">
          <span className="horizontal gap-8" style={{ marginBottom: 24 }}>
            <span className="linea-negra"></span>
            <p className="datos-upper-text">Más de 50 integraciones</p>
          </span>

          <p className="section-title">
            <span>Integraciones</span>
          </p>

          <p className="section-subtitle">
            Te conectamos con un mundo de datos. Integramos tus datos de
            múltiples fuentes, desde tu ERP hasta hojas de cálculo, para
            ofrecerte una visión unificada de tu negocio. Más de 50
            integraciones con proveedores de datos y las posibilidades de
            nuestras API abiertas.
          </p>

          <button
            className="boton-generico boton-blanco"
            style={{ fontSize: "1.1rem", lineHeight: "1.1rem" }}
            onClick={() => navigateAndScroll("/demo", "top")}
          >
            Solicitar una demo
            <FaArrowRight />
          </button>
        </div>
      </section>

      <section
        className="light-section"
        style={{ gap: "4rem", margin: "8rem 0 4rem 0" }}
      >
        <div className="columna" style={{ width: "55%" }}>
          {/* <span className="horizontal gap-8" style={{ marginBottom: 24 }}>
            <span className="linea-negra"></span>
            <p className="datos-upper-text">Más de 50 integraciones</p>
          </span> */}

          <p className="section-title">
            <span>
              Obtenga{" "}
              <span style={{ color: "var(--red-highlight)" }}>
                soluciones personalizadas
              </span>{" "}
              con nuestro equipo de <br /> profesionales
            </span>
          </p>

          <div className="columna" style={{ marginBlock: "2rem" }}>
            {[
              "Maximiza tu ROI con soluciones de BI a medida.",
              "Transforma tus datos en valor con nuestras soluciones de BI.",
              "Implementación ágil para un impacto inmediato.",
              "Soluciones de BI personalizadas para un crecimiento sostenible y una rápida adaptación al cambio.",
            ].map((x, index) => (
              <div
                className="horizontal"
                style={{ marginBlock: 8, gap: "0.5rem" }}
                key={index}
              >
                <img
                  alt="tick"
                  src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/tick.png`}
                  style={{ width: "1.25rem" }}
                />
                <p style={{ fontFamily: "Space Grotesk, san-serif" }}>{x}</p>
              </div>
            ))}
          </div>
          {/* <p className="section-subtitle">
            Te conectamos con un mundo de datos. Integramos tus datos de
            múltiples fuentes, desde tu ERP hasta hojas de cálculo, para
            ofrecerte una visión unificada de tu negocio. Más de 50
            integraciones con proveedores de datos y las posibilidades de
            nuestras API abiertas.
          </p> */}

          <WhatsappLink>
            <button
              className="boton-generico boton-blanco"
              style={{ fontSize: "1.1rem", lineHeight: "1.1rem" }}
            >
              Más info
              <FaArrowRight />
            </button>
          </WhatsappLink>
        </div>

        <div className="columna" style={{ width: "45%" }}>
          <img
            alt="integraciones"
            src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/equipobi-39.png`}
          />
        </div>
      </section>

      <section
        className="centered-section"
        style={{ marginBottom: 50, position: "relative" }}
      >
        <span
          className="horizontal gap-8"
          style={{
            color: "white",
            marginInline: "auto",
            width: "fit-content",
          }}
        >
          <span className="linea-negra"></span>
          <p className="datos-upper-text">Enfocando en la protección</p>
          <span className="linea-negra"></span>
        </span>
        <p
          className="section-title"
          style={{
            marginInline: "auto",
            textAlign: "center",
            margin: "2rem 0px",
          }}
        >
          <span style={{ color: "var(--red-highlight)" }}>Confiabilidad</span> y{" "}
          <br />
          <span style={{ color: "var(--red-highlight)" }}>seguridad</span> de
          los datos
        </p>
        <p
          className="centered-section-subtitle"
          style={{ textAlign: "center" }}
        >
          Empleamos las últimas tecnologías de encriptación y<br />
          protección de datos para garantizar que tu información esté siempre a
          salvo.
        </p>
        <div className="seguridad-layout">
          {ELEMENTS.map(({ title, subtitle, imgSrc }, index) => (
            <div className="seguridad-card" key={index}>
              <img alt={title} style={{ width: "100%" }} src={imgSrc} />
              <div className="columna" style={{ gap: "0.5rem" }}>
                <b style={{ fontSize: "1.4rem" }}>{title}</b>
                <p style={{ fontSize: "1.25rem" }}>{subtitle}</p>
              </div>
            </div>
          ))}
        </div>

        <div
          className="columna"
          style={{ alignItems: "center", marginTop: "2rem" }}
        >
          <p
            className="centered-section-subtitle"
            style={{ marginBlock: "1rem" }}
          >
            Protege tus datos con nosotros
          </p>
          <WhatsappLink>
            <button className="boton-generico boton-blanco">
              Más info
              <FaArrowRight />
            </button>
          </WhatsappLink>
        </div>

        {/* <div style={{ width: "90%", marginInline: "auto" }}>
          <img
            alt="pasos"
            src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/pasos.png`}
            style={{ width: "100%" }}
          />
        </div> */}
      </section>

      <section
        className="centered-section"
        style={{ marginBottom: 50, position: "relative" }}
      >
        <p
          className="section-title"
          style={{ marginInline: "auto", textAlign: "center" }}
        >
          ¿Es la inteligencia de negocios sólo una palabra de moda?
        </p>

        <p className="centered-section-subtitle">Dementimos mitos con hechos</p>
      </section>
    </>
  );
};

export default Otros;
